<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">我的收藏</span>
      </div>
    </div>
    <div v-if="userlivecollect.length > 0">
      <div class="display_between marginTop20"
           v-for="(item, index) in userlivecollect"
           :key="index + '1'">
        <div class="pub_square"
             v-for="(itemx, indexx) in item"
             :key="indexx + '11'"
             @click="liveinfo(itemx.live_id)">
          <div class="pubs_img">
            <img :src="Date.parse(itemx.start_time) < new Date() && Date.parse(itemx.end_time) > new Date() ? require('../../../assets/img/live/live.png')
                : Date.parse(itemx.end_time) < new Date() && !itemx.isPlayback ? require('../../../assets/img/live/over.png')
                    : Date.parse(itemx.end_time) < new Date() && itemx.isPlayback ? require('../../../assets/img/live/playback.png')
                        : Date.parse(itemx.start_time) > new Date() ? require('../../../assets/img/live/notice.png') : require('../../../assets/img/live/live.png')"
                 style="position: absolute; " />
            <img class="pubs_img"
                 :src="itemx.coverPictureUrl" />
          </div>
          <div class="pubs_body">
            <div class="pubs_title"
                 :title="itemx.title">{{ ellipsis(itemx.title, 17) }}</div>
          </div>
          <div class="display_between"
               v-if="itemx.org_name!=null && itemx.org_name!=''">
            <div class="pubs_tip pubs_body">
              <span style=""><img :src="itemx.orgLogoUrl"
                     width="18px" /></span>
              <span style="position: absolute;color: #000; margin-left: 10px; 
                            line-height: 20px;"
                    :title="itemx.org_name">{{ ellipsis(itemx.org_name, 17) }}</span>
            </div>
          </div>
          <div class="display_between">
            <div class="pubs_tip pubs_body">
              <span>开直播时间:</span>
              <span class="normalColor"> {{ formatTime(itemx.start_time, 'YYYY-MM-DD') }} 至 {{
                                formatTime(itemx.end_time, 'YYYY-MM-DD')
                            }}</span>
            </div>
          </div>
          <div class="display_between"
               style="float: right;"
               @click.stop="collection(itemx.live_id)">
            <div class="pubs_body"
                 style="padding-top: 10px;">
              <div style="border: 1px red solid; border-radius: 5px;
                             width: 80px; line-height: 25px;
                             font-size: 14px; text-align: center; 
                            background-color: red; color: #fff;">
                <span>取消收藏</span>
              </div>
            </div>
          </div>
        </div>
        <div class="pub_square1"
             v-for="zhw in 3 - item.length"
             :key="zhw"></div>
      </div>
    </div>
    <div v-else>
      <ul class="NoneData">
        <p>
          <span>您还没有收藏过任何直播！</span>
        </p>
      </ul>
    </div>
  </div>
</template>
<script>
import format from '@/assets/unit/unit.js';
import lodash from 'lodash';
export default {
  name: 'userMyMeeting',
  data () {
    return {
      AuthorId: 0,
      userlivecollect: [],
      userlivecollectall: []
    };
  },
  created () {
    if (localStorage.getItem('ResData')) {
      this.AuthorId = JSON.parse(localStorage.getItem('ResData')).id;
    }
    this.getTrainMeetingList();
  },
  methods: {
    /*全国全科会议及培训*/
    getTrainMeetingList () {
      let _this = this;
      this.httphelper.post('/api/LiveTrainApi/GetUserSubLivie', {
        userId: this.AuthorId,
        type: 3,
        page: 1,
        limit: 99999
      })
        .then(res => {
          if (res.data.code == 200) {
            _this.userlivecollectall = res.data.data;
            _this.userlivecollect = lodash.chunk(res.data.data, 3);
          }
        });
    },
    formatTime (datatime, timeformat) {
      return format(datatime, timeformat);
    },
    liveinfo (liveid) {
      var url = 'https://live.gp519.com/detail?id=' + liveid
      window.open(url, '_blank');
    },
    collection (liveid) {
      this.$confirm('你确定要取消收藏？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.httphelper.post('/api/LiveTrainApi/DeleteGpLiveFavorites', {
          trainId: liveid,
          userId: this.AuthorId
        })
          .then(res => {
            var newarr = this.userlivecollectall.filter(function (item) {
              return item["live_id"] != liveid
            })
            this.userlivecollectall = newarr;
            this.userlivecollect = lodash.chunk(newarr, 3);
            this.$message({
              type: 'success',
              message: '已经成功取消收藏!'
            });


          })
      })
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .pubs_body {
    padding-top: 10px;
}

.pubs_title {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 20px;
    font-weight: bold;
    overflow: hidden;
    height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* 块状列表 */
.pub_square {
    width: 300px;
    height: 300px;
    background: #ffffff;
    border-radius: 0px 0px 5px 5px;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.04);
}

.pub_square1 {
    width: 300px;
    height: 300px;
    background: #ffffff;
    border-radius: 0px 0px 5px 5px;
    /* box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.04); */
}

.NoneData {
    padding: 40px;
    text-align: center;
    color: #999;
    font-size: 18px;
    letter-spacing: 1px;
}
</style>
